/**
 * ImageLoaded Component
 */

import * as imageloaded from 'imagesloaded';
import * as React from 'react';
import { findDOMNode } from 'react-dom';

export interface IImageLoadedRenderProps {
  imageLoaded: boolean;
  reloadImage(): void;
}

interface IImageLoadedProps {
  background?: boolean | string;
  children(props: IImageLoadedRenderProps): React.ReactNode;
}

interface IImageLoadedState {
  imageLoaded: boolean;
}

export default class ImageLoaded extends React.Component<IImageLoadedProps, IImageLoadedState> {
  didMount = false;
  imgLoad;

  constructor(props) {
    super(props);

    this.state = {
      imageLoaded: false,
    };
  }

  componentDidMount() {
    this.didMount = true;
    this.imgLoad = imageloaded(findDOMNode(this), { background: this.props.background });
    this.loadImage();
  }

  componentWillUnmount() {
    this.didMount = false;
    this.imgLoad = null;
  }

  onImageLoaded = () => {
    if (this.didMount) {
      this.setState({ imageLoaded: true });
    }
  }

  loadImage = () => {
    if (this.didMount) {
      this.imgLoad.on('always', this.onImageLoaded);
    }
  }

  render() {
    return this.props.children({
      imageLoaded: this.state.imageLoaded,
      reloadImage: this.loadImage,
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/ImageLoaded.tsx